export default __webpack_public_path__ + "static/media/zodiacToto-Snake.f5061d2f.png";